import { render, staticRenderFns } from "./TooltipChip.vue?vue&type=template&id=89444e82&scoped=true&"
import script from "./TooltipChip.vue?vue&type=script&lang=ts&"
export * from "./TooltipChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89444e82",
  null
  
)

export default component.exports